import { opacityTransitionDurationMs } from '#/components/styles';

export const controlsConfig = {
  fadeOutDelay: 3,
  seekTime: 10,
  /** Delay before the parental advisory fades in, measured from the moment the player controls start fading out. */
  parentalAdvisoryDelay: 1 + opacityTransitionDurationMs / 1000,
  /** How long the parental advisory stays up before it fades out. */
  parentalAdvisoryDuration: 6,
};
